// Clinic Configuration for Todays Dental Lexington
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Todays Dental Lexington",
  clinicId: "todaysdentallexington",
  clinicUrl: "https://todaysdentallexington.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=todaysdentallexington&agentId=061a0680-1e2b-4e95-b1f7-89c760dbb27b",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/todaysdentallexington/voice",

  // Contact Information
  phoneNumber: "(803) 756-4353",
  phoneNumberRaw: "+18037564353", // For tel: and sms: links
  email: "Dentist@TodaysDentalLexington.com",

  // Location
  address: "458 Old Cherokee Rd suite 100, Lexington, SC 29072, United States",
  addressShort: "458 Old Cherokee Rd suite 100, Lexington, SC 29072",
  city: "Lexington",
  hcity: "Lexington",
  state: "South Carolina",
  stateShortForm: "SC",
  PostalCode: "29072",

  // Map Links
  mapUrl: "https://maps.app.goo.gl/xMnrGnMJQcLVUCig6",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d51955.348891750866!2d-81.233431!3d34.005315!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f8979d05a0d829%3A0x592b6cdfeb60540f!2sTodays%20Dental%20%40%20Lexington!5e1!3m2!1sen!2sin!4v1759822010472!5m2!1sen!2sin',

  iframeTitle: "Todays Dental Lexington",

  //membership
  membership: "https://member.kleer.com/?slug=RB3P",

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/TodaysDentalatLexington",

  // Cherry
  cherryUrl: "https://pay.withcherry.com/todays-dental-at-lexington?utm_source=practice&utm_medium=email&m=65977",


  // Analytics
  clarityProjectId: "prcooafwqn",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/todaysdentallexington",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/todaysdentallexington",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/todaysdentallexington",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://todaysdentallexington.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/TodaysDentalLexington",
    instagram: "https://www.instagram.com/todaysdentallexington/",
    twitter: "https://twitter.com/td_lexington",
    linkedin: "https://www.linkedin.com/company/todays-dental-at-lexington/",
    youtube: "https://www.youtube.com/@todaysdentallexington",
  },

  // Open Dental Configuration
  defaultProvNum: 1,
  defaultOpNum: 21,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: "New patient emergency/other",
      label: "New patient emergency/other",
      duration: 30,
      opNum: 22,
      AppointmentTypeNum: 11,
    },
    {
      value: "Existing patient emergency/other",
      label: "Existing patient emergency/other",
      duration: 30,
      opNum: 11, // DEFAULT_OP_NUM
      AppointmentTypeNum: 21,
    },
    {
      value: "Existing patient current treatment Plan",
      label: "Existing patient current treatment Plan",
      duration: 30,
      opNum: 11, // DEFAULT_OP_NUM
      AppointmentTypeNum: 20,
    },
  ],

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:${this.phoneNumberRaw}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;
